export default "__VITE_ASSET__tTeID1s2__"